import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { finalize, map, take, takeUntil } from 'rxjs/operators';
import { Response } from '../../../models';
import { InvoiceService, SnackbarService, XeroConnectionService } from '../../../services';

@Component({
  selector: 'prism-xero-display',
  templateUrl: './xero-display.component.html',
  styleUrls: ['./xero-display.component.scss']
})
export class XeroDisplayComponent implements OnInit, OnDestroy {
  subDestroyer$: Subject<void>;
  creatingInvoice$: Observable<boolean>;
  displayXeroControl: boolean;
  xeroExpiryTimerSubject$: Observable<Observable<any>>;
  xeroExpiryTimer$: Observable<any>;
  organisation$: Observable<any>;
  xeroLoading$: Observable<boolean>;
  loadingQueue$: Observable<boolean>;
  getXeroConnectionDataSub: Subscription;
  disconnecting = false;

  constructor(private snackbarService: SnackbarService,
              private invoicesService: InvoiceService,
              private xeroConnectionService: XeroConnectionService) {
    this.subDestroyer$ = new Subject<void>();
    this.creatingInvoice$ = this.invoicesService.creatingInvoice$;
    this.displayXeroControl = false;
    this.xeroExpiryTimerSubject$ = this.xeroConnectionService.getXeroExpiryTimer();
    this.organisation$ = this.xeroConnectionService.organisation$;
    this.xeroLoading$ = this.xeroConnectionService.xeroLoading$;
  }

  ngOnInit() {
    this.xeroExpiryTimerSubject$
      .subscribe(timer => {
        this.xeroExpiryTimer$ = timer;
      });

    this.getXeroConnectionDataSub = this.xeroConnectionService.getXeroConnection()
      .pipe(
        takeUntil(this.subDestroyer$)
      )
      .subscribe(
        () => null,
        () => {
          this.xeroExpiryTimer$ = timer(0);
          console.error(`Error getting Xero connection data`);
        }
      );
  }

  connectToXero() {
    this.snackbarService.showSnackbar('Establishing connection with Xero...');
    this.xeroConnectionService.getToken()
      .pipe(
        takeUntil(this.subDestroyer$)
      )
      .subscribe(
        () => {
        },
        err => {
          console.error('Error getting Xero token:', err);
        }
      );
  }

  disconnectFromXero() {
    this.disconnecting = true;
    this.xeroConnectionService.disconnectXero()
      .pipe(
        take(1),
        finalize(() => this.disconnecting = false)
      )
      .subscribe(
        () => this.snackbarService.showSnackbar('Xero disconnected.'),
        err => {
          console.error('Error disconnecting Xero:', err);
          this.snackbarService.showSnackbar('Failed to disconnect Xero.');
        }
      );
  }

  createInvoice() {
    const sessionHasExpired = this.xeroConnectionService.sessionExpired;
    if (!sessionHasExpired) {
      this.invoicesService.postProcessorInvoice()
        .pipe(
          take(1),
          map((updateRes: Response) => updateRes.data)
        )
        .subscribe(() => null, (err) => console.error(err));
    }
  }

  toggleXeroDisplay() {
    this.displayXeroControl = !this.displayXeroControl;
  }

  ngOnDestroy() {
    this.subDestroyer$.next();
  }
}
